import { defaultLanguage } from "@/services/constants/global";
import { sortByKey } from "@/services/utils/formatter";
import { objectRemoveKeys } from "@/services/utils/general";
import { Select } from "@chakra-ui/react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

const getOptionLabel = (item, i18n, labelKey) => {
  if (labelKey) return item[`${labelKey}`];

  if (!get(item, "name")) return item;

  return item.name[i18n.language || defaultLanguage];
};

export default function AsyncSelect({
  queryKey = "",
  apiCall = () => {},
  value = "",
  defaultValue = "",
  onChange = () => {},
  labelKey = "",
  isSort = true,
  hidden = true,
  ...rest
}) {
  const { i18n } = useTranslation();
  const { data } = useQuery(queryKey, () => apiCall());

  const inputSortData = data?.docs || data;

  const showUpData =
    isSort && inputSortData?.length > 0
      ? sortByKey(
          inputSortData,
          labelKey ||
            (get(inputSortData[0], "name")
              ? `name.${i18n.language || "en"}`
              : "")
        )
      : inputSortData;

  return (
    <Select
      {...objectRemoveKeys(rest, ["placeholder"])}
      defaultValue={showUpData ? defaultValue : ""}
      value={value}
      onChange={onChange}
      isDisabled={!showUpData}
    >
      <option hidden={hidden} value="">
        {rest.placeholder}
      </option>
      {showUpData?.map((item) => {
        return (
          <option key={JSON.stringify(item)} value={item._id || item}>
            {getOptionLabel(item, i18n, labelKey)}
          </option>
        );
      })}
    </Select>
  );
}
